import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=377530fc"
import script from "./Upsell.vue?vue&type=script&lang=js"
export * from "./Upsell.vue?vue&type=script&lang=js"
import style0 from "./Upsell.vue?vue&type=style&index=0&id=377530fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports